import {i18n} from '@online-offer/i18n';
import {useFormatCurrency} from 'platform/locale';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {EMPTY_PLACEHOLDER} from 'shared/web';

import {formatFinancialProductMoney} from './formatFinancialProductMoney';
import {LeasingCostItem} from './getLeasingCostSections';

/**
 * The amount with its unit ("300 Kč / month", "3,50 Kč / km"). Every item carries an amount, so the
 * placeholder only stands in for one the formatter cannot read.
 */
export const formatLeasingCostAmount = (
  item: LeasingCostItem,
  formatCurrency: ReturnType<typeof useFormatCurrency>
) => {
  const amount = formatFinancialProductMoney(item.amount, formatCurrency, item.decimals);

  if (isNil(amount)) {
    return EMPTY_PLACEHOLDER;
  }

  return match(item.unit)
    .with('PER_MONTH', () => `${amount} ${i18n.t('financialProducts.leasingCosts.perMonth')}`)
    .with(
      'PER_KILOMETRE',
      () => `${amount} ${i18n.t('financialProducts.leasingCosts.perKilometre')}`
    )
    .with(null, () => amount)
    .exhaustive();
};
